module.exports = __webpack_public_path__ + "static/media/avator.1b86963e.png";